import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';

export default function configureStore(initialState) {
    const middleware = applyMiddleware(thunkMiddleware);
    return middleware(createStore)(initialState);
}



// WEBPACK FOOTER //
// ./src/_app/clients/storeConfiguration.js